import Footer from '../footer/Footer';
import Navbar from '../navbar/Navbar';
import FacilitiesLeftTab from './FacilitiesLeftTab';


const InfrastructurePhotos = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <FacilitiesLeftTab />
                        </div>

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Infrastructure & Facilities Photos
                                </h2>
                                <div className="container py-4">

                                    {/* 🏢 Campus & Buildings */}
                                    <h4 className="mb-3">Campus & Building Infrastructure</h4>
                                    <div className="row">
                                        {[
                                            'A-block.JPG',
                                            'A-block-copy.JPG',
                                            'B-BLOCK-Copy.JPG',
                                            'MBA-Block.JPG',
                                            'Block-1.jpg',
                                            'block-2.jpg',
                                            'swec-main-gate.JPG',
                                            'Placement-cell.png'
                                        ].map((fileName, index) => (
                                            <div className="col-md-6 pb-3" key={index}>
                                                <img
                                                    src={`https://admin.swec.ac.in/assetsswec/img/infrastructure/${fileName}`}
                                                    className="img-fluid rounded-1 sixteen-nine w-100"
                                                    alt={fileName}
                                                    loading="lazy"
                                                    title={fileName.replace(/[-_]/g, ' ').replace(/\.[^/.]+$/, '').replace(/\b\w/g, c => c.toUpperCase())}
                                                />
                                                
                                            </div>
                                        ))}
                                    </div>

                                    {/* 📚 Library & Digital Library */}
                                    <h4 className="mt-5 mb-3">Library & Digital Library</h4>
                                    <div className="row">
                                        {[
                                            'Digital-Library.JPG',
                                            'Library-1.JPG',
                                            'Library-2.JPG',
                                            'Library-3.JPG',
                                            'Library-4.JPG'
                                        ].map((fileName, index) => (
                                            <div className="col-md-6 pb-3" key={index}>
                                                <img
                                                    src={`https://admin.swec.ac.in/assetsswec/img/infrastructure/${fileName}`}
                                                    className="img-fluid rounded-1 sixteen-nine w-100"
                                                    alt={fileName}
                                                    loading="lazy"
                                                    title={fileName.replace(/[-_]/g, ' ').replace(/\.[^/.]+$/, '').replace(/\b\w/g, c => c.toUpperCase())}
                                                />
                                                
                                            </div>
                                        ))}
                                    </div>

                                    {/* 🏀 Sports Facilities */}
                                    <h4 className="mt-5 mb-3">Sports Facilities</h4>
                                    <div className="row">
                                        {[
                                            'Sports-Basketball.JPG',
                                            'Sports-Kabaddi.JPG',
                                            'Sports-Kho-Kho.JPG',
                                            'Sports-Throwball.JPG',
                                            'Sports-Volley-Ball.JPG'
                                        ].map((fileName, index) => (
                                            <div className="col-md-6 pb-3" key={index}>
                                                <img
                                                    src={`https://admin.swec.ac.in/assetsswec/img/infrastructure/${fileName}`}
                                                    className="img-fluid rounded-1 sixteen-nine w-100"
                                                    alt={fileName}
                                                    loading="lazy"
                                                    title={fileName.replace(/[-_]/g, ' ').replace(/\.[^/.]+$/, '').replace(/\b\w/g, c => c.toUpperCase())}
                                                />
                                              
                                            </div>
                                        ))}

                                        {/* Additional sports images */}
                                        <div className="col-md-6 pb-3">
                                            <img
                                                src="https://admin.swec.ac.in/assetsswec/img/sports/Sports_Ground.jpeg"
                                                className="img-fluid rounded-1 sixteen-nine w-100"
                                                alt="Sports Ground"
                                                title="Sports Ground"
                                                loading="lazy"
                                            />
                                        </div>

                                        <div className="col-md-6 pb-3">
                                            <img
                                                src="https://admin.swec.ac.in/assetsswec/img/sports/SWEC-Sports-Winners.jpg"
                                                className="img-fluid rounded-1 sixteen-nine w-100"
                                                alt="SWEC Sports Winners"
                                                title="SWEC Sports Winners"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>

                                    {/* 🛠️ Other Facilities */}
                                    <h4 className="mt-5 mb-3">Other Facilities</h4>
                                    <div className="row">
                                        {[
                                            'Activity-Room.JPG',
                                            'Cafeteria.JPG',
                                            'Gym.jpg',
                                            'Incinerator.jpg',
                                            'Sick-Room.jpg',
                                            'Smartboard-1.JPG',
                                            'Smartboard-2.JPG'
                                        ].map((fileName, index) => (
                                            <div className="col-md-6 pb-3" key={index}>
                                                <img
                                                    src={`https://admin.swec.ac.in/assetsswec/img/infrastructure/${fileName}`}
                                                    className="img-fluid rounded-1 sixteen-nine w-100"
                                                    alt={fileName}
                                                    title={fileName.replace(/[-_]/g, ' ').replace(/\.[^/.]+$/, '').replace(/\b\w/g, c => c.toUpperCase())}
                                                    loading="lazy"
                                                />
                                                
                                            </div>
                                        ))}
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default InfrastructurePhotos
